import { Injectable } from '@angular/core';
import { ModalKindStandalone } from '@bcf-v2-logic-worker-modals/shared/modal-kind-standalone.types';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalStandaloneResolverSignalService {
  private _alreadyResolved: ModalKindStandalone[] = [];

  public doLoadNewModal$: Subject<ModalKindStandalone> = new Subject<ModalKindStandalone>();
  public doUnloadModal$: Subject<ModalKindStandalone> = new Subject<ModalKindStandalone>();

  public resolve(kind: ModalKindStandalone) {
    return (state: boolean): void => {
      if (this._alreadyResolved.includes(kind) && !state) {
        this._alreadyResolved = this._alreadyResolved.filter(
          (resolvedKind: ModalKindStandalone) => resolvedKind !== kind
        );
        this.doUnloadModal$.next(kind);
      }
      if (!this._alreadyResolved.includes(kind) && state) {
        this._alreadyResolved.push(kind);
        this.doLoadNewModal$.next(kind);
      }
    };
  }
}
